import React from 'react';

const PolishFlag = ({ size = 24, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 900 600"
    width={size}
    height={(size * 2) / 3}
    {...props}
  >
    <rect width="900" height="600" fill="#fff" />
    <rect y="300" width="900" height="300" fill="#dc143c" />
  </svg>
);

export default PolishFlag; 